"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _actionForm = _interopRequireDefault(require("./actionForm.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Form, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_clicked", function () {
      if (!_this.props.submitButtonProps.isDisabled) {
        _this.props.handleSubmit();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_renderField", function (field, fieldInfo) {
      switch (fieldInfo.type) {
        case 'text':
          return /*#__PURE__*/_react["default"].createElement("input", _extends({
            className: "form-control input-sm",
            type: "text",
            placeholder: fieldInfo.label || fieldInfo.name
          }, (0, _domOnlyProps["default"])(field)));
        case 'selectbox':
          var options = fieldInfo.options.map(function (option) {
            return /*#__PURE__*/_react["default"].createElement("option", {
              key: option.value,
              value: option.value
            }, option.label);
          });
          return /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _domOnlyProps["default"])(field), {
            className: "form-control input-sm",
            id: "row_actions_".concat(field.name, "_select_box")
          }), options);
        case 'password':
          return /*#__PURE__*/_react["default"].createElement("input", _extends({
            className: "form-control input-sm",
            type: "password",
            placeholder: fieldInfo.label || fieldInfo.name
          }, (0, _domOnlyProps["default"])(field)));
        default:
          return null;
      }
    });
    return _this;
  }
  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        fields = _this$props.fields,
        fieldsArray = _this$props.fieldsArray,
        submitButtonProps = _this$props.submitButtonProps,
        submitting = _this$props.submitting;
      var rows = fieldsArray.map(function (fieldInfo) {
        var field = fields[fieldInfo.name];
        return /*#__PURE__*/_react["default"].createElement("span", {
          key: fieldInfo.name
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: 'form-group ' + _actionForm["default"].wrapper + ' ' + (field.touched && field.error ? 'has-error' : '')
        }, _this2._renderField(field, fieldInfo), field.touched && field.error && /*#__PURE__*/_react["default"].createElement("div", {
          className: _actionForm["default"].error
        }, field.error)), ' ');
      });
      var isLoading = submitting || submitButtonProps.isLoading;
      return /*#__PURE__*/_react["default"].createElement("span", null, rows, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], _extends({}, submitButtonProps, {
        isLoading: isLoading,
        className: "btn btn-primary btn-sm",
        onClick: this._clicked,
        isConfirm: false
      })));
    }
  }]);
  return Form;
}(_react["default"].Component);
_defineProperty(Form, "propTypes", {
  fields: _propTypes["default"].object.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  submitting: _propTypes["default"].bool.isRequired,
  fieldsArray: _propTypes["default"].array.isRequired,
  submitButtonProps: _propTypes["default"].object.isRequired
});
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: 'actionForm'
})(Form);